export default defineNuxtRouteMiddleware(async () => {
  const { data, suspense, isFetched } = useMaintenance()
  if (!isFetched.value) await suspense()
  if (data.value?.maintenance_mode === MaintenanceMode.START) {
    throw showError({
      statusCode: HttpStatusCode.ServiceUnavailable,
    })
  }
})
